import { AccordionItem } from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/accordion-item/AccordionItem";
import {
  DeliveryOption,
  DeliveryOptions,
} from "./DeliveryOptions/DeliveryOptions";
import { ProductDeliveryReturns } from "./ProductDeliveryReturns/ProductDeliveryReturns";
import { ExtendedReturnsPolicy } from "./ExtendedReturnsPolicy/ExtendedReturnsPolicy";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
import { useState } from "react";
import baseStyles from "../../ProductAccordion.module.scss";

export const PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME =
  "product-delivery-options";
export type ReturnsDateObj = Record<"year" | "month" | "date", number>;
export type Props = {
  deliveryOptions: DeliveryOption[];
  skuId: string;
  isAvailableToOrderOrPreorder: boolean;
  stockApiBaseUrl: string;
  stockApiKey: string;
  showExtendedReturnsMessaging: boolean;
  extendedReturnsDates: {
    startDate: string;
    endDate: string;
    deadlineDate: string;
  };
  isRetired: boolean;
  isInStoreOnly: boolean;
  isM2M: boolean;
  isMeteredProduct?: boolean;
  open?: boolean;
  browsePageHierarchy: Array<{ categoryId: string }>;
  sellingProductType?: string;
  showChristmasDeliveryMessaging: boolean;
  showOutletReturnMessage?: boolean;
  isBladedArticle?: boolean;
};

export function ProductDeliveryOptionsAccordionUI({
  deliveryOptions,
  skuId,
  isAvailableToOrderOrPreorder,
  stockApiBaseUrl,
  stockApiKey,
  showExtendedReturnsMessaging,
  extendedReturnsDates,
  isInStoreOnly,
  isRetired,
  isM2M,
  isMeteredProduct,
  open,
  browsePageHierarchy,
  sellingProductType = "",
  showOutletReturnMessage = false,
  isBladedArticle = false,
  showChristmasDeliveryMessaging,
}: Props) {
  const [isOpen, setIsOpen] = useState(open);
  if (isRetired) return null;
  if (isInStoreOnly) return null;

  return (
    <ProductAccordionWithMonetateEvents name="Delivery & Returns" open={isOpen}>
      <AccordionItem
        id="accordion-delivery"
        data-testid="accordion:delivery"
        header={
          <h2 className={baseStyles.accordionTitle}>Delivery and returns</h2>
        }
        aria-label="Delivery and returns"
        instanceName={PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME}
        isOpen={open}
        onStateChange={(isOpen: boolean) => {
          setIsOpen(isOpen);
        }}
      >
        {deliveryOptions.length > 0 && (
          <DeliveryOptions
            skuId={skuId}
            isAvailableToOrderOrPreorder={isAvailableToOrderOrPreorder}
            deliveryOptions={deliveryOptions}
            stockApiBaseUrl={stockApiBaseUrl}
            stockApiKey={stockApiKey}
          />
        )}
        <ProductDeliveryReturns
          browsePageHierarchy={browsePageHierarchy}
          sellingProductType={sellingProductType}
          showOutletReturnsMessage={showOutletReturnMessage}
          isBladedArticle={isBladedArticle}
          isM2M={isM2M}
          returnsStartDate={extendedReturnsDates.startDate}
          returnsEndDate={extendedReturnsDates.endDate}
          isMeteredProduct={isMeteredProduct}
          showChristmasDeliveryMessaging={showChristmasDeliveryMessaging}
        />
        {showExtendedReturnsMessaging && (
          <ExtendedReturnsPolicy {...extendedReturnsDates} />
        )}
      </AccordionItem>
    </ProductAccordionWithMonetateEvents>
  );
}
